import React from "react";
import { Navigation } from "swiper/modules";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";

const Tabs = ({ tabs }) => {
    return (
        <Swiper
            modules={[Navigation]}
            slidesPerView="auto"
            navigation={{
                nextEl: ".main-content__tabs-next",
                prevEl: ".main-content__tabs-prev",
            }}
            className="main-content__tabs"
        >
            {tabs?.length > 0 &&
                tabs?.map((tab) => {
                    return (
                        <SwiperSlide
                            key={tab.title}
                            className={`main-content__tab ${tab.isActive ? "main-content__tab--active" : ""}`}
                            onClick={tab.onClick} 
                            style={{ cursor: "pointer" }}
                        >
                            <span>{tab?.title}</span>
                        </SwiperSlide>
                    );
            })}

            <div className="main-content__tabs-prev">
                <i className="fa-solid fa-caret-left"></i>
            </div>
            <div className="main-content__tabs-next">
                <i className="fa-solid fa-caret-right"></i>
            </div>
        </Swiper>
    );
};

export default Tabs;
